<template>
    <div class="modal" v-if="showModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!--<button type="button" class="close" @click="closeModal">
              <span>&times;</span>
            </button>-->
            <h5 class="modal-title">{{ errorTitle }}</h5>            
          </div>
          <div class="modal-body {{ infoClass }}">
            <p>{{ errorMessage }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      errorTitle: {
        type: String,
        required: true
      },
      errorMessage: {
        type: String,
        required: true
      },
      infoClass: {
        type: String,
        required: true
      },
      modalEmit: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        showModal: false
      };
    },
    methods: {
      openModal() {
        this.showModal = true;
        console.log('showModal = true');
      },
      closeModal() {
        this.showModal = false;
        console.log('Inside closeModal');
        if (this.$props.modalEmit) {
          console.log('inside if');
          this.$emit('closeAction', true);
        }
      }
    }
  };
  </script>
  
  <style scoped>
    .modal {
        position: fixed; /* Ensure the modal stays fixed in the viewport */
        top: 0; /* Position it at the top of the viewport */
        left: 0; /* Position it at the left of the viewport */
        width: 100%; /* Make it take the full width of the viewport */
        height: 100%; /* Make it take the full height of the viewport */
        background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
        display: flex;
        justify-content: center; /* Center horizontally */
        align-items: center; /* Center vertically */
        z-index: 9999; /* Set a high z-index to ensure it appears on top of everything */
        color: black;
    }

    .modal-dialog {
        padding: 20px; /* Add some padding */
        border-radius: 5px; /* Add border-radius for rounded corners */
        display: block;
        width: 100%;
    }

    .modal-content {
      background-color: rgb(255, 255, 255);
    }

    .model-body {
      text-align: left;
    }

/* Add any other modal styles as needed */
  </style>